<template>
  <a-card :bordered='false'>

    <!-- 查询区域 -->
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <a-form-item label='规则名称'>
              <a-input placeholder='请输入规则名称' v-model='queryParam.ruleName'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label='规则Code'>
              <a-input placeholder='请输入规则Code' v-model='queryParam.ruleCode'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('button.search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('button.reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class='table-operator'>
      <a-button @click='handleAdd' type='primary' icon='plus'>{{ $t('button.add') }}</a-button>
      <a-button type='primary' icon='download' @click="handleExportXls('填值规则')">{{ $t('button.export') }}</a-button>
      <a-upload name='file' :showUploadList='false' :multiple='false' :headers='tokenHeader' :action='importExcelUrl' @change='handleImportExcel'>
        <a-button type='primary' icon='import'>{{ $t('button.import') }}</a-button>
      </a-upload>
      <a-dropdown v-if='selectedRowKeys.length > 0'>
        <a-menu slot='overlay'>
          <a-menu-item key='1' @click='batchDel'>
            <a-icon type='delete' />
            {{ $t('button.delete') }}
          </a-menu-item>
        </a-menu>
        <a-button style='margin-left: 8px'> {{ $t('button.batchOperation') }}
          <a-icon type='down' />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <a-alert type='info' showIcon style='margin-bottom: 16px;'>
      <template slot='message'>
        <span>{{ $t('tip.selected') }}</span>
        <a style='font-weight: 600;padding: 0 4px;'>{{ selectedRowKeys.length }}</a>
        <span>{{ $t('tip.term') }}</span>
        <template v-if='selectedRowKeys.length>0'>
          <a-divider type='vertical' />
          <a @click='onClearSelected'>{{ $t('button.clear') }}</a>
        </template>
      </template>
    </a-alert>

    <a-table
      ref='table'
      size='middle'
      bordered
      rowKey='id'
      :columns='columns'
      :dataSource='dataSource'
      :pagination='ipagination'
      :loading='loading'
      :rowSelection='{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}'
      @change='handleTableChange'>

        <span slot='action' slot-scope='text, record'>
          <a @click='handleEdit(record)'>{{ $t('button.edit') }}</a>
          <a-divider type='vertical' />
          <a-dropdown>
            <a class='ant-dropdown-link'>{{ $t('button.more') }} <a-icon type='down' /></a>
            <a-menu slot='overlay'>
              <a-menu-item @click='handleTest(record)'>
                功能测试
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm='() => handleDelete(record.id)'>
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

    </a-table>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <sys-fill-rule-modal ref='modalForm' @ok='modalFormOk' />
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage'
import SysFillRuleModal from './modules/SysFillRuleModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysFillRuleList',
  mixins: [JeecgListMixin],
  components: { SysFillRuleModal },
  data(){
    return {
      description: '填值规则管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: ( t, r, index ) => 1 + index
        },
        {
          title: '规则名称',
          align: 'center',
          dataIndex: 'ruleName'
        },
        {
          title: '规则Code',
          align: 'center',
          dataIndex: 'ruleCode'
        },
        {
          title: '规则实现类',
          align: 'center',
          dataIndex: 'ruleClass'
        },
        {
          title: '规则参数',
          align: 'center',
          dataIndex: 'ruleParams'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: `${ MTC_AUTH }sys/fillRule/list`,
        test: `${ MTC_AUTH }sys/fillRule/testFillRule`,
        delete: `${ MTC_AUTH }sys/fillRule/delete`,
        deleteBatch: `${ MTC_AUTH }sys/fillRule/deleteBatch`,
        exportXlsUrl: `${ MTC_AUTH }sys/fillRule/exportXls`,
        importExcelUrl: `${ MTC_AUTH }sys/fillRule/importExcel`
      }
    }
  },
  computed: {
    importExcelUrl(){
      return `${ window._CONFIG[ 'domianURL' ] }${ this.url.importExcelUrl }`
    }
  },
  methods: {
    handleTest( record ){
      let closeLoading = this.$message.loading('生成中...', 0)

      getAction(this.url.test, {
        ruleCode: record.ruleCode
      }).then(res => {
        if (res.success) {
          this.$info({
            title: '填值规则功能测试',
            content: '生成结果：' + res.result
          })
        } else {
          this.$message.warn(res.message)
        }
      }).finally(() => {
        closeLoading()
      })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>